// Serviço de envio de e-mail via backend

// Deploy unificado: sempre usar URL relativa
const getApiBaseUrl = () => "/api";

export const sendContactEmail = async (formData) => {
  try {
    // Mapear para os campos esperados pelo backend (Joi)
    const payload = {
      from_name: formData.fullName || formData.name || "",
      from_email: formData.email,
      phone: formData.phone,
      company: formData.company || "",
      service: formData.service || "",
      message: formData.message,
      hp: formData.honeypot || formData.hp || "",
    };

    const apiUrl = `${getApiBaseUrl()}/email/contact`;
    console.log("[EmailService] Enviando para:", apiUrl);

    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    });

    // Verificar se a resposta é JSON válido
    const contentType = response.headers.get("content-type");
    if (!contentType || !contentType.includes("application/json")) {
      const text = await response.text();
      console.error(
        "[EmailService] Resposta não é JSON:",
        text.substring(0, 200),
      );
      throw new Error(
        "Servidor retornou uma resposta inválida. Verifique se o backend está rodando.",
      );
    }

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data.message || `Erro ao enviar e-mail: ${response.status}`,
      );
    }

    return data;
  } catch (error) {
    console.error("Erro ao enviar e-mail:", error);

    if (
      error.message.includes("Failed to fetch") ||
      error.message.includes("NetworkError")
    ) {
      throw new Error(
        "Não foi possível conectar ao servidor. Verifique sua conexão.",
      );
    }

    if (error.message.includes("JSON")) {
      throw new Error(
        "Erro de comunicação com o servidor. Verifique se o backend está configurado corretamente.",
      );
    }

    throw new Error(
      error.message || "Falha ao enviar e-mail. Tente novamente.",
    );
  }
};

// Função para validar e-mail
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Função para formatar telefone
export const formatPhoneNumber = (phone) => {
  const numbers = phone.replace(/\D/g, "");
  if (numbers.length === 11) {
    return numbers.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
  } else if (numbers.length === 10) {
    return numbers.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
  }
  return phone;
};
